import { apiRequest } from '../api/http'

export interface NoonCatalogImportResult {
  rows: number
  imported: number
  mapped: number
  unmapped: number
  skipped: number
  issues: { row: number; partnerSku: string | null; code: string }[]
}

export type NoonCatalogImportJobStatus = 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED'

export interface NoonCatalogImportJob {
  id: number
  channelConnectionId: number
  status: NoonCatalogImportJobStatus
  createdAt: string
  updatedAt: string
  result: NoonCatalogImportResult | null
  errorCode: string | null
}

export function uploadNoonCatalog(accessToken: string, connectionId: number, file: File): Promise<NoonCatalogImportJob> {
  const formData = new FormData()
  formData.append('file', file)
  return apiRequest('/api/channels', `/${connectionId}/products/imports/noon-catalog/jobs`, {
    method: 'POST', accessToken, formData,
  })
}

export function getLatestNoonCatalogImportJob(accessToken: string, connectionId: number): Promise<NoonCatalogImportJob | null> {
  return apiRequest('/api/channels', `/${connectionId}/products/imports/noon-catalog/jobs/latest`, { accessToken })
}

export function getNoonCatalogImportJob(accessToken: string, connectionId: number, jobId: number): Promise<NoonCatalogImportJob> {
  return apiRequest('/api/channels', `/${connectionId}/products/imports/noon-catalog/jobs/${jobId}`, { accessToken })
}
